import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';

export interface BulkEditConfigurationComponentProps {
    show: boolean;
    onClick: VoidFunction;
}

export const BulkEditConfigurationComponent: React.FC<BulkEditConfigurationComponentProps> = (props) => {
    const { show, onClick } = props;

    const { t } = useTranslation();

    return (
        show && (
            <PocButton
                className="bulk-action"
                data-testid="bulk-action-edit"
                variant="tertiary"
                size="medium"
                onClick={onClick}
            >
                <PocIcon slot="prefix" name="write" family="outlined" />
                {t('settings.devices.device-settings.device-config-layout.bulk.action.edit')}
            </PocButton>
        )
    );
};
